// extracted by mini-css-extract-plugin
module.exports = {"section":"B2_section__xD8Ob"};